import * as React from "react";
import { Slide, useTheme } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertColor, AlertProps } from "@mui/material/Alert";
import { AppActions } from "@/Redux/CommonApp/appSlice";
import { useAppDispatch, useAppSelector } from "@/Redux/app/hooks";
import { RootState } from "@/Redux/Store";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
) {
    return <MuiAlert elevation={5} ref={ref} {...props} />;
});
function SlideTransition(props: React.ComponentProps<typeof Slide>) {
    return <Slide {...props} direction="left" />;
}
interface SnackBarState {
    open: boolean;
    type: AlertColor;
    message: string;
}
export default function CommonSnackBar() {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const snackBar = useAppSelector(
        (state: RootState) => state.app.common.snackBar as SnackBarState
    );
    const handleClose = () => {
        dispatch(
            AppActions.actions.setSnackBar({
                open: false,
                type: snackBar.type,
                message: snackBar.message,
            })
        );
    };
    const color = theme.palette[(snackBar.type || "success") as AlertColor]?.light;

    return (
        <Snackbar
            open={snackBar.open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            TransitionComponent={SlideTransition}
            disableWindowBlurListener
            sx={{
                maxWidth: "500px",
                "&>.MuiPaper-root::after": {
                    content: "\"\"",
                    position: "absolute",
                    height: "2px",
                    width: "calc(100% - 8px)",
                    backgroundColor: color,
                    bottom: 0,
                    left: "4px",
                    animation: "width-animation 6s forwards",
                },
            }}
            style={{
                left: "auto",
                right: "24px",
            }}
        >
            <Alert
                onClose={handleClose}
                severity={snackBar.type}
                sx={{
                    borderLeft: `4px solid ${color}`,
                    bgcolor: theme.palette.background.paper,
                    whiteSpace: "pre-line"
                }}
            >
                {snackBar.message}
            </Alert>
        </Snackbar>
    );
}
